import React, { Component } from 'react';

import { TaxIcon } from '../../Assets/Settings/SettingsIcon';

import DeliveryMethodForm from '../../Components/Form/DeliveryForm/DeliveryMethodForm';
import FormLayout from '../../Components/Layout/FormLayout';
import { t } from 'i18next';

class AddDeliveryMethod extends Component {
  componentDidMount() {
    document.title = 'Add Delivery Method';
  }

  renderDeliveryMethodForm() {
    return (
      <DeliveryMethodForm
        title="New Delivery Method"
        type="add"
        handleToast={this.props.handleToast}
      />
    );
  }

  render() {
    return (
      <FormLayout
        title={t('Settings.delivery_methods')}
        Icon={TaxIcon}
        subtitle={t('Settings.add_new')}
        closeUrl="/deliverymethods"
      >
        {this.renderDeliveryMethodForm()}
      </FormLayout>
    );
  }
}

export default AddDeliveryMethod;
